var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.getClassName},[_c('InputValidator',{attrs:{"config":{
      dataLpignore: true,
      errorStyleExceptions: _vm.getErrorExceptionStyle,
      name: _vm.field,
      placeholder: _vm.placeholder,
      readonly: !_vm.isSelected || _vm.showReadOnly,
      validate: _vm.validation,
      value: _vm.item[_vm.field],
    },"name":_vm.field},on:{"InputValidatorChange":_vm.handleInputOnBlur,"InputValidatorFocus":_vm.handleInputOnFocus,"InputValidatorModel":_vm.handleInputOnChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }